// easyBike variant cache fix - patches renderProductInfo to prevent caching issue
// This ensures selecting a new product variant always fetches fresh data
// and properly re-enables the Add to Cart button on errors.
document.addEventListener('DOMContentLoaded', function() {
  function patchVariantSelects() {
    var el = document.querySelector('variant-selects, variant-radios');
    if (!el) return; // No variant selects on this page

    var proto = Object.getPrototypeOf(el);
    if (!proto.renderProductInfo || proto.__ebCacheFixed) return;
    proto.__ebCacheFixed = true;

    var _orig = proto.renderProductInfo;
    proto.renderProductInfo = function(productUrl, targetId, callback) {
      var self = this;
      this.abortController && this.abortController.abort();
      this.abortController = new AbortController();

      fetch(productUrl, {
        signal: this.abortController.signal,
        cache: 'no-store'
      })
        .then(function(r){ return r.text(); })
        .then(function(text){
          var html = new DOMParser().parseFromString(text, 'text/html');
          callback(html);
        })
        .then(function(){
          var target = document.getElementById(targetId);
          if (target) {
            target.focus();
            if (target.tagName === 'OPTION') target.selected = true;
          }
        })
        .catch(function(e){
          if (e.name !== 'AbortError') {
            console.error('[easyBike] renderProductInfo error:', e);
            self.toggleAddButton && self.toggleAddButton(false);
          }
        });
    };
  }

  // Try immediately, then retry briefly in case elements aren't ready
  patchVariantSelects();
  setTimeout(patchVariantSelects, 500);
});
